// extracted by mini-css-extract-plugin
export default {"tooltipFitContent":"styles_tooltipFitContent__A6-o9","breadcrumbText":"styles_breadcrumbText__uVxLD"};